export default __webpack_public_path__ + "static/media/mainloader.97fa88ed.svg";